function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CableCar = /*#__PURE__*/function () {
  function CableCar(cableReady) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        mimeType = _ref.mimeType;

    _classCallCheck(this, CableCar);

    this.cableReady = cableReady;
    this.mimeType = mimeType !== null && mimeType !== void 0 ? mimeType : 'application/vnd.cable-ready.json';
    this.boundPerform = this.perform.bind(this);
  }

  _createClass(CableCar, [{
    key: "name",
    get: function get() {
      return 'CableCar';
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var anyHeader = window.mrujs.mimeTypes.any;
      window.mrujs.registerMimeTypes([{
        shortcut: 'any',
        header: "".concat(this.mimeType, ", ").concat(anyHeader)
      }, {
        shortcut: 'cablecar',
        header: this.mimeType
      }]);
    }
  }, {
    key: "connect",
    value: function connect() {
      document.addEventListener('ajax:beforeNavigation', this.boundPerform);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener('ajax:beforeNavigation', this.boundPerform);
    }
  }, {
    key: "perform",
    value: function perform(event) {
      var _this = this;

      var fetchResponse = event.detail.fetchResponse;
      if ((fetchResponse === null || fetchResponse === void 0 ? void 0 : fetchResponse.contentType) == null) return;
      if (!this.isCableReadyResponse(fetchResponse.contentType)) return;
      event.preventDefault();
      fetchResponse.json().then(function (response) {
        _this.cableReady.perform(response);
      }).catch(function (err) {
        console.error(err);
      });
    }
  }, {
    key: "isCableReadyResponse",
    value: function isCableReadyResponse(contentType) {
      return Boolean(contentType.includes(this.mimeType));
    }
  }]);

  return CableCar;
}();

function JsErb() {
  var name = 'JsErb';
  return {
    name: name,
    initialize: initialize$2,
    connect: connect$1,
    disconnect: disconnect$2
  };
}

function initialize$2() {
  var _window$mrujs$mimeTyp = window.mrujs.mimeTypes,
      script = _window$mrujs$mimeTyp.script,
      any = _window$mrujs$mimeTyp.any;
  window.mrujs.registerMimeTypes([{
    shortcut: 'any',
    header: "".concat(script, ", ").concat(any)
  }]);
}

function connect$1() {
  document.addEventListener('ajax:complete', injectScriptIntoHead);
}

function disconnect$2() {
  document.removeEventListener('ajax:complete', injectScriptIntoHead);
}

function injectScriptIntoHead(event) {
  var _a, _b, _c, _d;

  if (!isJavascriptResponse((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.fetchResponse) === null || _b === void 0 ? void 0 : _b.contentType)) return; // https://github.com/rails/rails/blob/fa1a4b657c7167a8671a359a55de3f9b37f4330b/actionview/app/assets/javascripts/rails-ujs/utils/ajax.coffee#L13

  var script = document.createElement('script');
  var csp = window.mrujs.cspNonce();
  if (csp != null) script.setAttribute('nonce', csp);
  window.mrujs.enableElement(event);
  (_d = (_c = event.detail) === null || _c === void 0 ? void 0 : _c.fetchResponse) === null || _d === void 0 ? void 0 : _d.text().then(function (html) {
    var _a, _b;

    script.text = html;
    (_b = (_a = document.head.appendChild(script)) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(script);
    var _event$detail = event.detail,
        element = _event$detail.element,
        fetchRequest = _event$detail.fetchRequest,
        fetchResponse = _event$detail.fetchResponse; // @ts-expect-error

    window.mrujs.navigationAdapter.navigate(element, fetchRequest, fetchResponse); // ^ not sure this is actually needed, but we'll leave it just in case.
  }).catch(function (err) {
    return console.error(err);
  });
}

function isJavascriptResponse(contentType) {
  if (contentType == null) return false;
  return Boolean(contentType.match(/\b(?:java|ecma)script\b/));
}

function MrujsTurbo() {
  return {
    name: 'MrujsTurbo',
    initialize: initialize$1,
    connect: connect,
    disconnect: disconnect$1
  };
}

var mimeType = 'text/vnd.turbo-stream.html';

function initialize$1() {
  var anyHeader = window.mrujs.mimeTypes.any;
  window.mrujs.registerMimeTypes([{
    shortcut: 'any',
    header: "".concat(mimeType, ", ").concat(anyHeader)
  }, {
    shortcut: 'turbo',
    header: mimeType
  }]);
}

function connect() {
  document.addEventListener('ajax:beforeNavigation', handleTurboStream);
}

function disconnect$1() {
  document.removeEventListener('ajax:beforeNavigation', handleTurboStream);
}

function handleTurboStream(event) {
  var fetchResponse = event.detail.fetchResponse;
  if (fetchResponse == null) return;
  if (!isTurboResponse(fetchResponse.contentType)) return;
  event.preventDefault(); // => stop the navigationAdapter from trying to handle it.

  fetchResponse.html().then(function (responseHtml) {
    // @ts-expect-error
    window.Turbo.renderStreamMessage(responseHtml);
  }).catch(function (err) {
    console.error(err);
  });
}

function isTurboResponse(contentType) {
  return Boolean(contentType.includes(mimeType));
}

function Shoelace() {
  return {
    name: 'Shoelace',
    initialize: initialize,
    disconnect: disconnect
  };
}

function initialize() {
  document.addEventListener('sl-submit', shoelaceFormListener);
}

function disconnect() {
  document.removeEventListener('sl-submit', shoelaceFormListener);
}

function shoelaceFormListener(event) {
  var form = event.currentTarget;
  var formData = event.detail.formData;
  var action = form.getAttribute('action');
  var method = form.getAttribute('method');

  if (action == null) {
    console.warn("No 'action' attribute on your Shoelace form. Aborting...");
    return;
  }

  if (method == null) method = 'get'; // @ts-expect-error

  window.mrujs.fetch(action, {
    element: form,
    dispatchEvents: true,
    method: method,
    body: window.mrujs.urlEncodeFormData(formData)
  }).then(function () {}).catch(function (err) {
    return console.warn(err);
  });
}

export { CableCar, JsErb, MrujsTurbo, Shoelace };